import React from "react";
import { useSelector } from "react-redux";
import Moment from "moment";
import { formatDecimal } from "../../../util/decimalFormatter";
const OrdersTable = ({
  orderType,
  orders = [],
  t,
  onCancel,
  onEdit,
  manageScreenSize,
  submitLock,
}) => {
  const livePrices = useSelector((state) => state.market.prices);

  const renderHeaders = () => {
    switch (orderType) {
      case "all":
        return (
          <tr>
            <th>{t("Pair")}</th>
            <th>{t("Direction")}</th>
            <th>{t("Type")}</th>
            <th>{t("Quantity, lots")}</th>
            <th>{t("Entry point")}</th>
            <th>{t("Price change")}</th>
            <th>{t("Take Profit")}</th>
            <th>{t("Stop Loss")}</th>
            <th>{t("Status")}</th>
            <th>{t("OrderID")}</th>
            <th>{t("Action")}</th>
          </tr>
        );
      case "working":
        return (
          <tr>
            <th>{t("Pair")}</th>
            <th>{t("Direction")}</th>
            <th>{t("Quantity, lots")}</th>
            <th>{t("Entry Price")}</th>
            <th>{t("Price change")}</th>
            <th>{t("Take Profit")}</th>
            <th>{t("Stop Loss")}</th>
            <th>{t("Action")}</th>
          </tr>
        );
      case "filled":
        return (
          <tr>
            <th>{t("Pair")}</th>
            <th>{t("Direction")}</th>
            <th>{t("Quantity, lots")}</th>
            <th>{t("Open time")}</th>
            <th>{t("Close time")}</th>
            <th>{t("Entry Price")}</th>
            <th>{t("Closed Price")}</th>
            <th>{t("Trigger By")}</th>
            <th>{t("Commission")}</th>
            <th>{t("Gross Profit")}</th>
            <th>{t("P & L")}</th>
          </tr>
        );
      case "cancelled":
        return (
          <tr>
            <th>{t("Pair")}</th>
            <th>{t("Direction")}</th>
            <th>{t("Quantity, lots")}</th>
            <th>{t("Entry Price")}</th>
            <th>{t("Take Profit")}</th>
            <th>{t("Stop Loss")}</th>
            <th>{t("Date & Time")}</th>
          </tr>
        );
      default:
        return null;
    }
  };

  const renderRow = (order, i) => {
    const live = livePrices[order.symbol?.toUpperCase()];
    const livePrice = order.side === "BUY" ? live?.ask : live?.bid;
    const common = {
      pair: order.symbol || "-",
      direction: (
        <span
          style={{
            color:
              order.side === "BUY" || order.side === "long"
                ? "#00BC8B"
                : "#f23345",
          }}
        >
          {order.side}
        </span>
      ),
      quantity: order.quantity,
      price_change: livePrice,
    };

    switch (orderType) {
      case "all":
        return (
          <tr key={i}>
            <td>{common.pair}</td>
            <td>{common.direction}</td>
            <td>{order.order_type}</td>
            <td>{common.quantity}</td>
            <td>{formatDecimal(order.price)}</td>
            <td>
              {order.status === "pending"
                ? formatDecimal(common.price_change)
                : "-"}
            </td>
            <td>
              {order.take_profit ? formatDecimal(order.take_profit) : "-"}
            </td>
            <td>{order.stop_loss ? formatDecimal(order.stop_loss) : "-"}</td>
            <td>{order.status}</td>
            <td>{order.id}</td>
            <td>
              {order.status === "pending"
                ? onCancel && (
                    <i
                      className="bi bi-x-circle text-danger"
                      onClick={() => onCancel(order.id)}
                    />
                  )
                : "-"}
            </td>
          </tr>
        );
      case "working":
        return (
          <tr key={i}>
            <td>{common.pair}</td>
            <td>{common.direction}</td>
            <td>{common.quantity}</td>
            <td>{formatDecimal(order.price)}</td>
            <td>
              {order.status === "pending"
                ? formatDecimal(common.price_change)
                : "-"}
            </td>
            <td>
              {order.take_profit ? formatDecimal(order.take_profit) : "-"}
            </td>
            <td>{order.stop_loss ? formatDecimal(order.stop_loss) : "-"}</td>
            <td>
              {order.status === "pending" ? (
                <>
                  {onCancel && (
                    <i
                      className="bi bi-x-circle text-danger "
                      onClick={() => onCancel(order.id)}
                    />
                  )}
                  {/* {onEdit && (
                    <i
                      className="bi bi-pencil-square mr-2"
                      onClick={() => onEdit(order)}
                    />
                  )} */}
                </>
              ) : (
                "-"
              )}
            </td>
          </tr>
        );
      case "filled":
        return (
          <tr key={i}>
            <td>{common.pair}</td>
            <td>{common.direction}</td>
            <td>{common.quantity}</td>
            <td>{Moment(order.created_at).format("lll")}</td>
            <td>{Moment(order.closed_at).format("lll")}</td>
            <td>
              {order.entry_price ? formatDecimal(order.entry_price) : "-"}
            </td>
            <td>
              {order.close_price ? formatDecimal(order.close_price) : "-"}
            </td>
            <td>{order.trigger_by ?? "-"}</td>
            <td>{order.fee ? formatDecimal(order.fee) : "-"}</td>
            <td
              style={
                order.gross_profit > 0
                  ? { color: "rgb(0, 188, 139)" }
                  : { color: "rgb(242, 54, 69)" }
              }
            >
              {order.gross_profit ? formatDecimal(order.gross_profit) : "-"}
            </td>
            <td
              style={
                order.pnl > 0
                  ? { color: "rgb(0, 188, 139)" }
                  : { color: "rgb(242, 54, 69)" }
              }
            >
              {order.pnl ? formatDecimal(order.pnl) : "-"}
            </td>
          </tr>
        );
      case "cancelled":
        return (
          <tr key={i}>
            <td>{common.pair}</td>
            <td>{common.direction}</td>
            <td>{common.quantity}</td>
            <td>{formatDecimal(order.price)}</td>
            <td>
              {order.take_profit ? formatDecimal(order.take_profit) : "-"}
            </td>
            <td>{order.stop_loss ? formatDecimal(order.stop_loss) : "-"}</td>
            <td>{Moment(order.created_at).format("lll")}</td>
          </tr>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={
        manageScreenSize === "tv_chart_container2-zero"
          ? "trading_table-f"
          : "trading_table trading_table2222"
      }
    >
      <table className="table">
        <thead>{renderHeaders()}</thead>
        <tbody>
          {orders.length === 0 ? (
            <tr>
              <td colSpan={12} className="text-center text-muted py-3">
                {t("No orders found")}
              </td>
            </tr>
          ) : (
            orders.map((order, i) => renderRow(order, i))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersTable;
